module.exports = __webpack_public_path__ + "img/coming-soon.a41eb09e.jpg";